/**
 * Reconciliation Exceptions (FSD Part 3, S04: FIN-T01-R015, V042, V043, the
 * "Investigate Exception" action and the Bank Reconciliation Dashboard report).
 * The wiring packet spreads `TREASURY_RECONCILIATION_EXCEPTIONS_ROUTES` beside
 * the treasury routes and adds the p03 nav item
 * `treasury-reconciliation-exceptions`.
 *
 * Gated on `bankrec.exception.read` — what `GET /reconciliations/exceptions`
 * declares. Assign, investigate and resolve need `bankrec.exception.manage`,
 * checked on the screen and again by the server.
 *
 * This file imports nothing from `treasury/routes.ts`, which will spread it, so
 * the spread cannot become an import cycle.
 */

import type { RouteRecordRaw } from 'vue-router'

import { RECON_EXCEPTION_PERMISSIONS } from '@/modules/treasury/reconciliation-exceptions/permissions'

export const TREASURY_RECONCILIATION_EXCEPTIONS_PATH = '/treasury/reconciliation-exceptions'

/** The register narrowed to one bank account — the link a session or dashboard row uses. */
export function reconciliationExceptionsFor(bankAccountId: number): string {
  return `${TREASURY_RECONCILIATION_EXCEPTIONS_PATH}?bankAccountId=${bankAccountId}`
}

export const TREASURY_RECONCILIATION_EXCEPTIONS_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_RECONCILIATION_EXCEPTIONS_PATH,
    name: 'treasury-reconciliation-exceptions',
    component: () =>
      import('@/modules/treasury/reconciliation-exceptions/ReconciliationExceptionsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.reconciliationExceptions',
      permission: RECON_EXCEPTION_PERMISSIONS.read,
    },
  },
]
